export default "{\n\"key\": \"value\"\n}"